/* Dezine Kids — stable sticky offsets v2.
   Header geometry is measured only when its SIZE can change, never on scroll. */
(function () {
  function initStickyRefinement() {
    var header = document.getElementById('header');
    if (!header) return;

    var root = document.documentElement;
    var brandBar = document.getElementById('brandAZBar');
    var frame = 0;
    var lastHeight = -1;

    function measureHeader() {
      frame = 0;
      var height = Math.max(0, Math.round(header.offsetHeight || 0));
      if (height === lastHeight) return;
      lastHeight = height;
      root.style.setProperty('--dk-sticky-header-offset', height + 'px');
    }

    function scheduleMeasure() {
      if (frame) return;
      frame = window.requestAnimationFrame(measureHeader);
    }

    /* Initial measurement. No scroll listener is used. */
    measureHeader();

    window.addEventListener('resize', scheduleMeasure, { passive: true });
    window.addEventListener('orientationchange', scheduleMeasure, { passive: true });
    window.addEventListener('load', scheduleMeasure, { once: true });

    /* Logo/font/layout changes are caught without polling while scrolling. */
    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(scheduleMeasure);
      resizeObserver.observe(header);
    }

    /* Avone toggles stickyHeader classes at its threshold. We re-check size,
       but only write the CSS variable if the actual height changed. */
    var mutationObserver = new MutationObserver(scheduleMeasure);
    mutationObserver.observe(header, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    /* Correct A–Z anchor landing: target stays below header + alphabet bar. */
    if (brandBar) {
      brandBar.addEventListener('click', function (event) {
        var link = event.target.closest('a[href^="#brand-"]');
        if (!link) return;

        var selector = link.getAttribute('href');
        var target = document.querySelector(selector);
        if (!target) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var headerHeight = lastHeight >= 0 ? lastHeight : (header.offsetHeight || 0);
        var barHeight = brandBar.offsetHeight || 0;
        var y = window.pageYOffset + target.getBoundingClientRect().top - headerHeight - barHeight - 8;

        window.scrollTo({
          top: Math.max(0, y),
          behavior: 'smooth'
        });

        if (history.replaceState) history.replaceState(null, '', selector);
      }, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyRefinement);
  } else {
    initStickyRefinement();
  }
})();
